import { useTranslation } from "react-i18next";
import { LANGUAGES, TRANSLATED_LANGUAGES } from "../i18n/languages";
import { usePrefs } from "../contexts/PrefsContext";
import { Languages } from "lucide-react";

/**
 * Compact language picker. Used in the public chrome (Landing, Login, Signup,
 * Forgot) and again inside Settings. Persists the choice to localStorage
 * unconditionally and to the user profile once authenticated.
 */
export default function LanguageSelector({ compact = false, testid = "language-selector" }) {
    const { i18n } = useTranslation();
    const { updatePrefs } = usePrefs();

    const onChange = (code) => {
        i18n.changeLanguage(code);
        localStorage.setItem("vu_lang", code);
        updatePrefs({ language: code });
    };

    const current = LANGUAGES.find(l => l.code === i18n.language)
                 || LANGUAGES.find(l => i18n.language?.startsWith(l.code.split("-")[0]))
                 || LANGUAGES[0];

    return (
        <div className={`relative inline-flex items-center gap-2 ${compact ? "text-xs" : "text-sm"}`} data-testid={testid}>
            {!compact && <Languages size={14} className="text-[var(--text-ink)]/55" aria-hidden />}
            <select value={current.code} onChange={(e) => onChange(e.target.value)}
                    aria-label="Language"
                    data-testid={`${testid}-select`}
                    className={`appearance-none bg-transparent border border-[rgba(26,19,24,0.15)] rounded-full ${compact ? "py-1 pl-2 pr-6" : "py-1.5 pl-3 pr-7"} hover:border-[var(--brand-purple)]/50 transition cursor-pointer`}>
                {LANGUAGES.map(l => (
                    <option key={l.code} value={l.code}>
                        {l.flag} {l.name}{TRANSLATED_LANGUAGES.has(l.code) ? "" : " · soon"}
                    </option>
                ))}
            </select>
        </div>
    );
}
